module.exports = __webpack_public_path__ + "media/img/pages/companies/nestle-dc712998d0a918fb651e760cd0ad8e86.png";